import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

import marketingConsentIcon from "Custom/Content/User/marketing-consent-icon.png";

export const UserAccessControl: any = styled(Box)`
    position: relative;
    font-weight: 500;
    font-style: normal;
    font-size: 36px;
    font-family: "Nexa Light";
    color: black;

    @media only screen and (max-width: ${breakpointTheme.breakpoints.values.md + "px"}) {
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.md + "px"}) and (max-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
    }

    .marketingconsenttext {
        padding-right: 16px;
        float: left;
    }

    .marketingconsenticon {
        background-origin: padding-box;
        background-position-x: center;
        background-position-y: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(${marketingConsentIcon});
        display: block;
        min-height: 70px;
        min-width: 70px;
        float: right;
    }
`;
